import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ToolbarComponent {}
